import styled from 'styled-components';
import { ReactComponent as Download } from '../../assets/icons/download.svg';

export const IconDownload = styled(Download)`
  width: 28px;
  height: 28px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 52px 0 40px 0;

  @media screen and (max-width: 960px) {
    padding: 24px 20px 32px 20px;
    border-radius: 0;
  }
`;

export const Container2 = styled.div`
  width: 624px;

  @media screen and (max-width: 960px) {
    width: 100%;
  }

  .footer {
    display: flex;
    justify-content: space-between;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: 960px) {
    border-radius: 0;
    width: 100%;
    justify-content: flex-start;
  }
`;

export const Title = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.primaryDark2};
  margin-bottom: 28px;

  @media screen and (max-width: 960px) {
    font-size: 24px;
    margin: 3px 0px 28px 15px;
  }
`;

export const SubWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 0 20px 0;

  @media screen and (max-width: 960px) {
    width: 100%;
    border-radius: 0;
  }
`;

export const Subtitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.gray};
  margin-bottom: 30px;

  @media screen and (max-width: 960px) {
    margin-bottom: 4px;
    font-size: 20px;
  }
`;

export const DetailContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  .datepicker-box {
    width: fit-content;
    display: flex;
    align-items: center;
  }
  .number {
    color: ${(props) => props.theme.colors.primaryDark2};
    font-weight: 700;
    font-size: 24px;
    margin-bottom: 8px;
  }

  .bank-name {
    font-weight: 700;
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 2px;
  }

  .default {
    display: flex;
    font-weight: 400;
    font-size: 12px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 4px;
    line-height: 130%;
    span {
      margin-left: 5px;
    }
  }

  .default2 {
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 4px;

    span {
      font-weight: 700;
    }
  }

  .space-right {
    margin-right: 4px;
  }

  .space-left {
    margin-left: 4px;
  }

  .contentText {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0px 15px;
  }

  .spanContent {
    margin-bottom: 2px;
    color: ${(props) => props.theme.colors.gray};
    font-size: 12px;
  }

  .contentInfo {
    display: flex;
    color: ${(props) => props.theme.colors.gray};
    margin-top: 4px;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 767px) {
    width: 70%;
    .number {
      font-size: 20px;
    }

    .bank-name {
      font-size: 16px;
    }

    .default {
      order: 2;
      font-size: 12px;
    }

    .default2 {
      order: 1;
      font-size: 14px;
    }

    div {
      margin-left: 4px;
    }

    .contentInfo {
      flex-direction: column;
    }
  }
`;

export const PixArea = styled.div`
  width: 350px;
  height: 350px;
  background-color: #fff;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  align-self: center;
  margin-top: 20px;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const QrCode = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .description {
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    color: ${(props) => props.theme.colors.black};
    margin-bottom: 28px;
  }
`;

export const Code = styled.div`
  margin: 20px 0 10px 0;
  white-space: nowrap;
  overflow: hidden;
  font-weight: bold;
  text-overflow: ellipsis;
  cursor: pointer;
`;

export const Button = styled.button<{ color: string; loading?: boolean }>`
  height: 20px;
  margin-top: 10px;
  color: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.white
      : props.theme.colors.primary};
  background: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.primary
      : props.theme.colors.white};
  text-transform: uppercase;
  padding: ${(props) => (props.loading ? '0 24px' : '19px')};
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.2);
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;

  p {
    margin-left: 8px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PaymentCard = styled.div`
  width: 100%;
  height: 68px;
  margin-top: 30px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '60px'};

  margin-bottom: 12px;
  padding: 20px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    cursor: pointer;
  }

  .text {
    padding: 6px 0;
    font-size: 20px;
    color: ${(props) => props.theme.colors.black};
    flex-grow: 10;
    @media screen and (max-width: 960px) {
      padding: 10px 0;
    }
  }

  .icon {
    flex-grow: 1;
  }

  @media screen and (max-width: 960px) {
    height: 72px;
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '10px'};
    padding: 18px;

    .text {
      font-size: 16px;
    }
  }
`;

export const PaymentResult = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
`;
